import * as BABYLON from "@babylonjs/core/Legacy/legacy";

import { config } from "../config.js";
import { GameScene } from "../scene";
import { fireConf } from "./fire_conf";

const log = console.log.bind(console);

// 默认是官网 需要设置为空
BABYLON.ParticleHelper.BaseAssetsUrl = "";

export class Fire {
	pss: BABYLON.ParticleSystemSet[];
	scene: GameScene;
	position: BABYLON.Vector3;
	constructor(scene: GameScene) {
		this.pss = [];
		this.scene = scene;
		this.position = new BABYLON.Vector3(0, 0, 0);
	}

	loadAssets(engine: BABYLON.Engine) {
		let scene = this.scene;
		let textures = [
			this.scene
				.GetAsset()
				.loadTexture(
					"./assets/particle_systems/Fire_SpriteSheet1_8x8.png",
					true,
					false,
				),
			this.scene
				.GetAsset()
				.loadTexture("./assets/particle_systems/sparks.png"),
			this.scene
				.GetAsset()
				.loadTexture(
					"./assets/particle_systems/Fire_SpriteSheet2_8x8.png",
					true,
					false,
				),
			this.scene
				.GetAsset()
				.loadTexture(
					"./assets/particle_systems/Fire_SpriteSheet3_8x8.png",
					true,
					false,
				),
		];
		let self = this;

		// 设置火的朝向 一个向左 一个向右
		let initRotations = [
			[Math.PI / 2, Math.PI / 2],
			[-Math.PI / 2, -Math.PI / 2],
		];
		// 设置火的位置 一个在左边 一个在右边
		let posXZ = [
			[0.2, 0],
			[-0.2, 0],
		];

		let d = fireConf;
		for (let i = 0; i < 2; i++) {
			let set = BABYLON.ParticleSystemSet.Parse(d, scene.bbScene, false);
			set.systems.forEach((ps: BABYLON.IParticleSystem, idx: number) => {
				ps.minSize = 0.4;
				ps.maxSize = 0.5;
				ps.minScaleY = 2.0;
				ps.spriteCellWidth = 128;
				if (idx === 1) {
				} else {
					ps.blendMode = BABYLON.ParticleSystem.BLENDMODE_STANDARD;

					// 设置随时间的 alpha 渐变  有渐变让火更有真实燃烧效果
					ps.removeColorGradient(0.1);
					ps.removeColorGradient(0.9);
					ps.addColorGradient(0.1, new BABYLON.Color4(1, 1, 1, 0.5));
					ps.addColorGradient(0.9, new BABYLON.Color4(1, 1, 1, 0.5));
				}

				ps.minInitialRotation += initRotations[i][0];
				ps.maxInitialRotation += initRotations[i][1];

				// 设置位置
				ps.emitter = new BABYLON.Vector3(
					this.position.x + posXZ[i][0],
					-10,
					this.position.z + posXZ[i][1],
				);
				ps.particleTexture = textures[idx];

				// applyFog 需要是类型 ParticleSystem 才能设置, 产生雾效果
				// 具体原理可以看粒子的 shader, shader 可以做扩展
				let basePs = ps as BABYLON.ParticleSystem;
				basePs.applyFog = true;
			});

			// 需要 start 才会动起来
			set.start();
			self.pss.push(set);
		}
	}

	// 设置火的位置 到不同位置的路面
	setPosition(x: number, z: number) {
		this.position.x = x;
		this.position.z = z;

		let posXZ = [
			[0.2, 0],
			[-0.2, 0],
		];
		for (let i = 0; i < this.pss.length; i++) {
			const set = this.pss[i];
			set.systems.forEach((ps: BABYLON.IParticleSystem, idx: number) => {
				let emitter = ps.emitter as BABYLON.Vector3;
				emitter.x = this.position.x + posXZ[i][0];
				emitter.z = this.position.z + posXZ[i][1];
			});
		}
	}

	// 用来设置火的垂直高度
	setY(y: number) {
		this.position.y = y;
		for (let i = 0; i < this.pss.length; i++) {
			const set = this.pss[i];
			set.systems.forEach((ps: BABYLON.IParticleSystem, idx: number) => {
				let emitter = ps.emitter as BABYLON.Vector3;
				emitter.y = this.position.y;
			});
		}
	}

	start() {
		for (let i = 0; i < this.pss.length; i++) {
			const set = this.pss[i];
			set.start();
		}
	}

	// 旋转  不同方向的路面需要旋转火的方向 才能让火对人
	rotate(y: number) {
		let fixedPoint = new BABYLON.Vector3(0, 1, 0);

		const rotQuart1 = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, y);
		const rotQuart2 = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, y);

		for (let i = 0; i < this.pss.length; i++) {
			const set = this.pss[i];
			set.systems.forEach((ps: BABYLON.IParticleSystem, idx: number) => {
				if (idx !== 1) {
					// 喷射方向
					// 喷射方向是物体坐标 不需要考虑世界坐标, 所以 point 是 fixedPoint
					let emit =
						ps.particleEmitterType as BABYLON.PointParticleEmitter;
					emit.direction1.rotateByQuaternionAroundPointToRef(
						rotQuart1,
						fixedPoint,
						emit.direction1,
					);
					emit.direction2.rotateByQuaternionAroundPointToRef(
						rotQuart2,
						fixedPoint,
						emit.direction2,
					);

					// 喷射位置
					// 喷射位置需要围绕 火的位置 旋转一定度数
					let emitter = ps.emitter as BABYLON.Vector3;
					emitter.rotateByQuaternionAroundPointToRef(
						rotQuart1,
						this.position,
						emitter,
					);
				}
			});
		}
	}

	update() {}
}

export class FirePool {
	fires: Fire[];
	scene: GameScene;

	constructor(scene: GameScene) {
		this.fires = [];
		this.scene = scene;
	}

	loadAssets(engine: BABYLON.Engine) {
		for (let i = 0; i < config.pathSegmentPreloadNum; i++) {
			let fire = new Fire(this.scene);
			fire.loadAssets(engine);
			this.fires.push(fire);
		}
	}

	getFire(): Fire {
		let res = this.fires.pop();
		res.setY(config.groundHeight + 0.2);
		return res;
	}

	returnFire(fire: Fire) {
		fire.setY(-10);
		this.fires.push(fire);
	}
}
